export function isImage(value) {
  if (!value || typeof value !== "object" || typeof value.image !== "string") return false;
  const url = value.image;
  return url.startsWith("img:") || url.startsWith("https://");
}

export function isImageUrl(value) {
  return value && typeof value === "string" && value.endsWith(".jpg");
}
